import { render, staticRenderFns } from "./laudoClinico.vue?vue&type=template&id=11ce43b8&scoped=true"
import script from "./laudoClinico.vue?vue&type=script&lang=js"
export * from "./laudoClinico.vue?vue&type=script&lang=js"
import style0 from "./laudoClinico.vue?vue&type=style&index=0&id=11ce43b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce43b8",
  null
  
)

export default component.exports